import clsx from "clsx";
import type { HTMLAttributes } from "react";

/** A rounded card with no hard grid lines. */
export function Card({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return <section className={clsx("card", className)} {...rest} />;
}
